import type {ReactElement} from 'react';
import {useState} from 'react';
import React from 'react';
import BaseNavOption from '@Components/poster-editor/components/poster-editor-nav-bar/components/base-nav-option/base-nav-option';
import {IconPlacement, Type} from '@Components/button';
import {useAppSelector} from '@/hooks';
import {NavRightSideOptionTypes} from '@Components/poster-editor/components/poster-editor-nav-bar/components/nav-right-options/nav-right-options.types';
import {closeEmbeddedEditor, EmbeddedEditorMessageType} from '@Libraries/embedded-editor';
import {generatePosterPreview} from '@Libraries/poster-library';

interface NavSaveOptionProps {
  saveOptionType?: NavRightSideOptionTypes;
}

export function EmbeddedEditorCustomButton({saveOptionType = NavRightSideOptionTypes.BUTTON}: NavSaveOptionProps): ReactElement<any> | null {
  const isPosterSaving = useAppSelector((state) => {
    return state.posterEditor.isPosterSaving;
  });
  const isEmbeddedExportMode = useAppSelector((state) => {
    return state.posterEditor.isEmbeddedExportMode;
  });
  const [isEmbeddedEditorClosing, setIsEmbeddedEditorClosing] = useState(false);
  const onEmbeddedEditorDone = async (): Promise<void> => {
    const hashedId = window.posterEditor?.whiteboard?.hashedID;

    if (hashedId) {
      await window.posterEditor?.whiteboard?.savePoster.save();
      const savedHashedId = window.posterEditor?.whiteboard?.hashedID;
      if (savedHashedId) {
        try {
          await generatePosterPreview(savedHashedId);
        } catch (e) {
          console.error(e);
        }
      }
      window.parent.postMessage(`${EmbeddedEditorMessageType.SAVE}~${savedHashedId}`, '*');
      setIsEmbeddedEditorClosing(false);
    } else {
      closeEmbeddedEditor();
    }
  };

  const getNextBtnCaption = (): string => {
    if (!window.posterEditor?.config?.nextBtnCaption) {
      return window.i18next.t('pmwjs_done');
    }

    return window.posterEditor?.config?.nextBtnCaption;
  };

  const showEmbeddedEditorCustomButton = (): ReactElement<any> | null => {
    if (window.PMW.isEmbedded() && !isEmbeddedExportMode) {
      return (
        <BaseNavOption
          id="nav-custom-next-option"
          icon="icon-arrow-right"
          text={getNextBtnCaption()}
          optionType={saveOptionType}
          onClickHandler={(): void => {
            setIsEmbeddedEditorClosing(true);
            void onEmbeddedEditorDone();
          }}
          iconPlacement={IconPlacement.RIGHT}
          hasMarginRight
          buttonType={Type.SECONDARY}
          disabled={isPosterSaving}
          isLoading={isEmbeddedEditorClosing}
          btnClasses="-noun"
        />
      );
    }

    return null;
  };

  return showEmbeddedEditorCustomButton();
}
